import { Link } from 'react-router-dom';
import { Shield, Lock, Clock, Eye, FileCheck2, Zap, Building2, ArrowRight, CheckCircle2, KeyRound, FileText, Link2, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

export default function Home() {
  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden tv-gradient-soft">
        <div className="absolute inset-0 tv-dots opacity-70 pointer-events-none" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 pb-20 md:pt-24 md:pb-28">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="animate-fade-up">
              <Badge className="bg-blue-100 text-[#0d63b0] hover:bg-blue-100 border-0 px-3 py-1">
                <Sparkles className="h-3.5 w-3.5 mr-1.5" /> Tecnologie srl · Verona
              </Badge>
              <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
                Quella password che hai appena inviato via email?
                <span className="block mt-2 bg-gradient-to-r from-[#0d63b0] to-[#1e88d6] bg-clip-text text-transparent">Vivrà lì per sempre.</span>
              </h1>
              <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
                Con <strong className="text-slate-900">Tecnologie Secure Push</strong> generi link cifrati che si
                auto-distruggono dopo la visualizzazione. Password, file e URL riservati condivisi in
                modo sicuro, senza account.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Button asChild size="lg" className="bg-[#0d63b0] hover:bg-[#0a4f8f] text-white h-12 px-6 shadow-md">
                  <Link to="/p/new">Crea un push gratuito <ArrowRight className="h-4 w-4 ml-1.5" /></Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="h-12 px-6 border-slate-300">
                  <Link to="/features">Scopri come funziona</Link>
                </Button>
              </div>
              <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-600">
                <span className="flex items-center gap-1.5"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> Nessun account richiesto</span>
                <span className="flex items-center gap-1.5"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> Cifratura AES-256</span>
                <span className="flex items-center gap-1.5"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> Auto-eliminazione</span>
              </div>
            </div>

            {/* Preview card */}
            <div className="relative animate-fade-up" style={{ animationDelay: '0.15s' }}>
              <div className="absolute -inset-4 bg-gradient-to-br from-blue-200/40 to-sky-100/50 rounded-3xl blur-2xl" />
              <Card className="relative border border-slate-200 shadow-xl bg-white p-6 rounded-2xl">
                <div className="flex items-center gap-2 pb-3 border-b border-slate-100">
                  <div className="flex gap-1.5">
                    <span className="h-2.5 w-2.5 rounded-full bg-red-400"></span>
                    <span className="h-2.5 w-2.5 rounded-full bg-yellow-400"></span>
                    <span className="h-2.5 w-2.5 rounded-full bg-emerald-400"></span>
                  </div>
                  <div className="flex-1 text-center">
                    <span className="text-xs text-slate-500 font-mono">push.tecsuite.it/p/a8f3k2m9</span>
                  </div>
                </div>
                <div className="mt-5 flex items-center gap-3">
                  <div className="h-11 w-11 rounded-lg bg-gradient-to-br from-[#0d63b0] to-[#1e88d6] flex items-center justify-center">
                    <Shield className="h-5 w-5 text-white" />
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900">Tecnologie srl</div>
                    <div className="text-xs text-slate-500">push.tecsuite.it</div>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider flex items-center gap-1.5"><Lock className="h-3.5 w-3.5" /> Push sicuro · Riservato</div>
                  <div className="mt-3 flex items-center gap-3">
                    <div className="flex-1 font-mono text-lg tracking-widest text-slate-400">••••••••••••</div>
                    <button className="text-xs font-semibold text-[#0d63b0] border border-[#0d63b0]/30 rounded-md px-2.5 py-1 hover:bg-blue-50">RIVELA</button>
                  </div>
                  <div className="mt-4 flex flex-wrap gap-2 text-xs">
                    <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-1"><Clock className="h-3 w-3" /> Scade in 2 giorni</span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-sky-50 text-sky-700 border border-sky-200 px-2.5 py-1"><Eye className="h-3 w-3" /> 3 vis. rimaste</span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 px-2.5 py-1"><Lock className="h-3 w-3" /> Protetto</span>
                  </div>
                </div>
                <div className="mt-5 pt-4 border-t border-slate-100">
                  <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Registro attività</div>
                  <ul className="mt-3 space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                      <div className="flex-1"><span className="text-slate-700">Push creato</span><span className="text-slate-400 float-right text-xs">oggi 14:32</span></div>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#0d63b0] pulse-dot"></span>
                      <div className="flex-1"><span className="text-slate-700">Visualizzato dal destinatario</span><span className="text-slate-400 float-right text-xs">15:07</span></div>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-slate-300"></span>
                      <div className="flex-1"><span className="text-slate-500">Scadenza automatica</span><span className="text-slate-400 float-right text-xs">tra 2gg</span></div>
                    </li>
                  </ul>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="border-y border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { k: '15+', v: 'Anni di esperienza IT' },
              { k: '128', v: 'Recensioni Google' },
              { k: 'AES-256', v: 'Cifratura end-to-end' },
              { k: '100%', v: 'GDPR compliant' },
            ].map((s) => (
              <div key={s.v}>
                <div className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-[#0d63b0] to-[#1e88d6] bg-clip-text text-transparent">{s.k}</div>
                <div className="mt-1 text-sm text-slate-600">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROBLEM / SOLUTION */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#0d63b0]">Il problema</div>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900">Sai già come va a finire.</h2>
            <p className="mt-4 text-slate-600">Un cliente ha bisogno di una password. La scrivi via email, WhatsApp, Teams o Slack. Quel messaggio
              vive per sempre — ricercabile, inoltrabile, dimenticato nei log.</p>
          </div>

          <div className="mt-12 grid md:grid-cols-2 gap-6">
            <Card className="border border-red-200 p-6 bg-red-50/40">
              <div className="text-sm font-semibold text-red-700">✗ Come fanno tutti</div>
              <div className="mt-4 font-mono text-sm text-slate-800 bg-white border border-slate-200 rounded-lg p-4">
                <div className="text-slate-500"><span className="font-semibold text-slate-700">Da:</span> tu@azienda.it</div>
                <div className="text-slate-500"><span className="font-semibold text-slate-700">Oggetto:</span> Credenziali di accesso</div>
                <div className="mt-3 text-slate-800">Ciao, ecco le credenziali staging:<br />Utente: admin<br />Password: Tr0ub4dor&amp;3</div>
              </div>
              <p className="mt-4 text-xs text-slate-500 italic">— vive nella sua casella email per sempre</p>
              <div className="mt-3 flex flex-wrap gap-2 text-xs text-red-700">
                <span>Ricercabile</span> · <span>Inoltrabile</span> · <span>Nessuna scadenza</span>
              </div>
            </Card>
            <Card className="border border-emerald-200 p-6 bg-emerald-50/40">
              <div className="text-sm font-semibold text-emerald-700">✓ Cosa dovresti fare</div>
              <div className="mt-4 font-mono text-sm text-slate-800 bg-white border border-slate-200 rounded-lg p-4">
                <div className="text-slate-500"><span className="font-semibold text-slate-700">Da:</span> tu@azienda.it</div>
                <div className="text-slate-500"><span className="font-semibold text-slate-700">Oggetto:</span> Credenziali di accesso</div>
                <div className="mt-3 text-slate-800">Ecco le tue credenziali staging:<br /><span className="text-[#0d63b0]">push.tecsuite.it/p/a8f3…</span></div>
              </div>
              <p className="mt-4 text-xs text-slate-500 italic">— scade in 3 giorni o dopo 1 visualizzazione</p>
              <div className="mt-3 flex flex-wrap gap-2 text-xs text-emerald-700">
                <span>Cifrato</span> · <span>Auto-scadenza</span> · <span>Registro attività</span>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-20 bg-slate-50/70">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#0d63b0]">Come funziona</div>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900">Tre passi. Semplice davvero.</h2>
            <p className="mt-4 text-slate-600">Niente software da installare. Funziona in qualsiasi browser. Sei operativo in un minuto.</p>
          </div>
          <div className="mt-14 grid md:grid-cols-3 gap-6">
            {[
              { n: 1, t: 'Incolla il tuo segreto', d: 'Password, chiave API, credenziali o testo riservato. Allega file se ti serve.', i: KeyRound },
              { n: 2, t: 'Imposta le regole', d: 'Visualizzazioni, tempo limite o entrambi. Aggiungi una passphrase per maggior sicurezza.', i: Clock },
              { n: 3, t: 'Condividi il link', d: 'Invialo come vuoi. Una volta visto o scaduto, il contenuto viene eliminato definitivamente.', i: Link2 },
            ].map((s) => (
              <Card key={s.n} className="tv-card-hover border border-slate-200 bg-white p-8 relative">
                <div className="absolute -top-4 left-8 h-8 w-8 rounded-full bg-[#0d63b0] text-white text-sm font-bold flex items-center justify-center shadow">{s.n}</div>
                <s.i className="h-8 w-8 text-[#0d63b0] mt-2" />
                <h3 className="mt-4 text-xl font-bold text-slate-900">{s.t}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{s.d}</p>
              </Card>
            ))}
          </div>
          <div className="mt-10 text-center">
            <Button asChild size="lg" className="bg-[#0d63b0] hover:bg-[#0a4f8f] text-white h-12 px-6">
              <Link to="/p/new">Crea il tuo primo push <ArrowRight className="h-4 w-4 ml-1.5" /></Link>
            </Button>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#0d63b0]">Perché sceglierlo</div>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900">Più di un link. Una piattaforma di sicurezza.</h2>
          </div>
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { i: Lock, t: 'Cifratura AES-256', d: 'Contenuti cifrati lato server con chiavi effimere. Anche i database non vedono il testo in chiaro.' },
              { i: Clock, t: 'Scadenza flessibile', d: 'Fino a 90 giorni o 100 visualizzazioni. Il contenuto si auto-distrugge — non lo archivia.' },
              { i: KeyRound, t: 'Passphrase opzionale', d: 'Aggiungi un livello di protezione con una passphrase condivisa fuori-canale.' },
              { i: FileText, t: 'File, testo, URL', d: 'Supporta note, credenziali, file allegati fino a 5MB e URL da rivelare una sola volta.' },
              { i: FileCheck2, t: 'Dashboard sessione', d: 'Rivedi e revoca i push generati con lo stesso browser. Nessun account necessario.' },
              { i: Building2, t: 'Personalizzato Tecnologie', d: 'Marchio, colori e dominio dedicati. Il tuo cliente vede Tecnologie, non un servizio anonimo.' },
            ].map((f) => (
              <Card key={f.t} className="tv-card-hover border border-slate-200 p-6">
                <div className="h-11 w-11 rounded-lg bg-blue-50 border border-blue-100 flex items-center justify-center">
                  <f.i className="h-5 w-5 text-[#0d63b0]" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-slate-900">{f.t}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{f.d}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 bg-slate-50/70">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#0d63b0]">Cosa dicono i clienti</div>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900">Non lo diciamo noi. Lo dicono loro.</h2>
            <div className="mt-4 flex items-center justify-center gap-2 text-sm text-slate-600">
              <span className="font-bold text-slate-900">ECCELLENTE</span>
              <span className="text-amber-500">★★★★★</span>
              <span>in base a 128 recensioni Google</span>
            </div>
          </div>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {[
              { n: 'Davide Stander', r: 'Competenti e veloci. Preparati, veloci e prezzi giusti. Consigliati.' },
              { n: 'Giovanni Bisazza', r: 'Efficienti, veloci, competenti. I migliori in assoluto per la nostra azienda.' },
              { n: 'Gigliola Mazzi', r: 'Professionale, puntuale, risolutivo. Assistenza remota da manuale.' },
            ].map((t) => (
              <Card key={t.n} className="border border-slate-200 p-6 bg-white">
                <div className="text-amber-500 text-lg">★★★★★</div>
                <p className="mt-3 text-slate-700 leading-relaxed">“{t.r}”</p>
                <div className="mt-4 flex items-center gap-3 pt-4 border-t border-slate-100">
                  <div className="h-9 w-9 rounded-full bg-blue-100 text-[#0d63b0] font-bold flex items-center justify-center text-sm">{t.n.split(' ').map(w=>w[0]).join('')}</div>
                  <div>
                    <div className="font-semibold text-slate-900 text-sm">{t.n}</div>
                    <div className="text-xs text-slate-500">Recensione Google</div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* RESELLER CTA */}
      <section className="py-16">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <Card className="relative overflow-hidden border border-slate-200 bg-white">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="p-10 md:p-12">
                <Badge className="bg-blue-100 text-[#0d63b0] hover:bg-blue-100 border-0">Per studi, aziende e team</Badge>
                <h2 className="mt-4 text-3xl md:text-4xl font-extrabold text-slate-900">Il tuo brand, la tua Secure Push.</h2>
                <p className="mt-4 text-slate-600">Offri Secure Push ai tuoi clienti con logo, colori, dominio e testi personalizzati. Bianca marca, professionale, senza riferimenti al fornitore.</p>
                <ul className="mt-5 space-y-2 text-sm text-slate-700">
                  <li className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> URL brandizzato <span className="font-mono text-[#0d63b0]">/b/tuobrand/…</span></li>
                  <li className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> Dominio custom <span className="font-mono text-[#0d63b0]">secure.tuobrand.it</span></li>
                  <li className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-emerald-600" /> White-label completo (piano Pro)</li>
                </ul>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Button asChild size="lg" className="bg-[#0d63b0] hover:bg-[#0a4f8f] text-white h-11 px-5">
                    <Link to="/register">Registrati <ArrowRight className="h-4 w-4 ml-1.5" /></Link>
                  </Button>
                  <Button asChild size="lg" variant="outline" className="h-11 px-5">
                    <Link to="/pricing">Vedi i piani</Link>
                  </Button>
                </div>
              </div>
              <div className="relative bg-gradient-to-br from-[#0d63b0] to-[#1e88d6] p-10 md:p-12 text-white flex items-center">
                <div className="absolute inset-0 tv-dots opacity-20" />
                <div className="relative">
                  <div className="text-xs font-semibold uppercase tracking-widest text-white/80">Esempio</div>
                  <div className="mt-2 font-mono text-sm bg-white/10 border border-white/20 rounded-lg px-3 py-2 backdrop-blur-sm">secure.acme-it.com/p/…</div>
                  <div className="mt-4 text-sm text-white/90">Il tuo cliente Acme vedrà solo il logo e i colori di Acme — un servizio white-label completamente sotto il tuo brand.</div>
                  <div className="mt-6 grid grid-cols-3 gap-3 text-center">
                    <div className="bg-white/10 border border-white/20 rounded-lg p-3">
                      <div className="text-2xl font-extrabold">€19</div>
                      <div className="text-[10px] uppercase tracking-widest text-white/70">Starter</div>
                    </div>
                    <div className="bg-white/15 border border-white/30 rounded-lg p-3 ring-1 ring-white/50">
                      <div className="text-2xl font-extrabold">€49</div>
                      <div className="text-[10px] uppercase tracking-widest text-white/80">Pro</div>
                    </div>
                    <div className="bg-white/10 border border-white/20 rounded-lg p-3">
                      <div className="text-2xl font-extrabold">∞</div>
                      <div className="text-[10px] uppercase tracking-widest text-white/70">Push</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <Card className="relative overflow-hidden border-0 shadow-xl">
            <div className="absolute inset-0 bg-gradient-to-br from-[#0d63b0] to-[#1e88d6]" />
            <div className="absolute inset-0 tv-dots opacity-20" />
            <div className="relative p-10 md:p-14 text-white text-center">
              <h2 className="text-3xl md:text-4xl font-extrabold">Pronto a condividere i segreti nel modo giusto?</h2>
              <p className="mt-4 text-white/90 max-w-2xl mx-auto">Nessun account, nessuna installazione, nessun tracciamento. Un link cifrato che scompare quando non serve più.</p>
              <div className="mt-8 flex flex-wrap justify-center gap-3">
                <Button asChild size="lg" className="bg-white text-[#0d63b0] hover:bg-blue-50 h-12 px-6 font-semibold shadow">
                  <Link to="/p/new"><Zap className="h-4 w-4 mr-1.5" /> Crea Push ora</Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="h-12 px-6 border-white/40 text-white hover:bg-white/10 hover:text-white">
                  <Link to="/features">Vedi funzionalità</Link>
                </Button>
              </div>
              <div className="mt-6 text-xs text-white/80">AES-256 cifrato · Dati in EU · GDPR · Auto-eliminazione</div>
            </div>
          </Card>
        </div>
      </section>
    </div>
  );
}
